import React from "react";

export default function StudioFooter({ code, label }) {
  return (
    <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-brand-hair pt-6 font-mono text-[10px] uppercase tracking-[0.28em] text-brand-mute md:flex-row md:items-center">
      <div className="flex items-center gap-4">
        <span>{code ? `${code} · ${label}` : "\u00A9 2026 AuthorOS by Zebralearn"}</span>
      </div>
      <div className="flex items-center gap-4">
        <span>AuthorOS by Zebralearn · 2026</span>
      </div>
    </div>
  );
}
